import React from 'react'
import Navbar from '../Components/Navbar'
import Firstadvertise from './Firstadvertise'
import iphone12promaxratingstar from './img/iphone12promaxratingstar.png'
import iphone12ratingstar from './img/iphone12ratingstar.png'
import iphone12pro from './img/iphone 12 pro.jpg'
import iphone11 from './img/iphone 11.jpg'
import appleiphone12pro from './img/iphone 12.jpg'
import iphoneXr from './img/iphone XR.jpg'
import Categoriescomponent from '../Components/Categoriescomponent'


import Bottombar from '../Components/Bottombar'

const Firstadvertisementarea=()=> {
        return (
            <React.Fragment>
                <Navbar/>
                <Firstadvertise 
                visit="/Firstproductcomponent"
                brand="iPhone" 
                offer="Bumper offer" 
                brandName="New Apple iPhone 12 Pro Max (128GB) - " 
                brandColor={<span style={{color: "#1BA4C3", fontWeight: "bold"}}>Pacific Blue</span>}
                price="Rs. 1,29,900" 
                img={iphone12promaxratingstar} alt="iphone 12 pro max" 
                display="6.7 Inches" os="IOS 14" memory="128GB" color="Pacific Blue" supply="Abailable, Hurry up" 
                imgphone={iphone12pro} altphone="iphone 12 pro" 
                offer1="Upto Rs.19,900 off." 
                offer2="on Kotak Debit/Credit Cards, 10% off, up to" offer2Rs="₹1500." 
                offer3="up to, 40%" 
                offer4="EMI on select cards for orders above" offer4Rs="₹3000." 
                offer5="up to 10% off," offer5Rs="₹1500."
                buy="/Buy"
                />
                
                <Firstadvertise 
                visit="/Firstproduct2details"
                brandName="Latest Apple iPhone 11 (64GB) - " 
                brandColor={<span style={{color: "rgb(223, 223, 223)", fontWeight: "bold",
                textShadow: "-1px 1px 0 #9AD1EE", fontSize: "28px"}}>White</span>} 
                price="Rs. 49,900" 
                img={iphone12promaxratingstar} alt="iphone 11" 
                display="6.1 Inches" os="A13 Bionic chip." memory="64GB" color={<span style={{color: "black"}}>White</span>} 
                supply="Abailable, Hurry up" 
                imgphone={iphone11} altphone="iphone 11" 
                offer1="Upto Rs.1,990 off." 
                offer2="on Fino Debit/Credit Cards, 9% off, up to" offer2Rs="₹4590." 
                offer3="up to, 40%" 
                offer4="EMI on select cards for orders above" offer4Rs="₹1200." 
                offer5="up to 3% off," offer5Rs="₹1200."
                buy="/Buy"
                />


                <Firstadvertise 
                visit="/Firstproduct3details"
                brandName="Latest Apple iPhone 12 (64GB) - " 
                brandColor={<span style={{color: "#053559", fontWeight: "bold"}}>Blue</span>}
                price="Rs. 79,900" 
                img={iphone12ratingstar} alt="iphone 12" 
                display="6.1 Inches" os="IOS 14" memory="64GB" color={<span style={{color: "#053559"}}>Blue</span>} 
                supply="Abailable, Hurry up" 
                imgphone={appleiphone12pro} altphone="iphone 12" 
                offer1="Upto Rs.9,990 off." 
                offer2="on HDFC Debit/Credit Cards, 5% off, up to" offer2Rs="₹3995." 
                offer3="up to, 40%" 
                offer4="EMI on select cards for orders above" offer4Rs="₹1000." 
                offer5="up to 5% off," offer5Rs="₹3995."
                buy="/Buy"
                />   


                <Firstadvertise 
                visit="/Firstproduct4details"
                brandName="Apple iPhone XR (64GB) - " 
                brandColor={<span style={{color: "black", fontWeight: "bold"}}>Black</span>}
                price="Rs. 47,900" 
                img={iphone12ratingstar} alt="iphone XR" 
                display="6.1 Inches" os="IOS 12" memory="64GB" color={<span style={{color: "Black"}}>Black</span>} 
                supply={<span style={{color: "red", fontWeight:"600", fontSize: "18px"}}>Currently unavailable</span>} 
                imgphone={iphoneXr} altphone="iphone XR" 
                offer1="Upto Rs.4,790 off." 
                offer2="on ICICI Debit/Credit Cards, 10% off, up to" offer2Rs="₹4790." 
                offer3="up to, 40%" 
                offer4="EMI on select cards for orders above" offer4Rs="₹1500." 
                offer5="up to 8% off," offer5Rs="₹38" 
                buy="/Buy"/>
                <Categoriescomponent/>
                <Bottombar/>
            </React.Fragment>
        )
}

export default Firstadvertisementarea
